export const LOGIN_ROUTE: string = '/login';
export const HOME_ROUTE: string = '/home';
export const CLASSES: string = '/classes';
export const SIGN_UP: string = '/sign-up';
export const REGISTRATION_ROUTE: string = '/registration';
export const TEST_ERROR_ROUTE: string = '/test-error';
export const TICKETS: string = '/tickets';
export const PURCHASE_HISTORY: string = '/purchase_history';
export const BONUSES: string = '/bonuses';
export const VISITS_HISTORY: string = '/visits_history';
export const SWIMMERS_DIARY: string = '/achievements';
export const CERTIFICATES: string = '/certificates';
export const FILEUPLOADER: string = '/fileuploader';
